import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '@/lib/api/client';
import { qk } from '@/lib/query/keys';

export function useBulkTagRecipes() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ ids, tag }: { ids: number[]; tag: string }) =>
      api<{ tagged: number }>('/recipes/bulk-tag', {
        method: 'POST',
        body: JSON.stringify({ ids, tag }),
      }),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: qk.recipes.all });
      void queryClient.invalidateQueries({ queryKey: qk.recipeTags });
    },
  });
}
